import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { Box } from "@mui/system";

export default function ExpertPaymentCheckboxChild({ selected, onToggle }) {
    return (
        <Box>
            <Checkbox
                checked={selected}
                onChange={onToggle}
                sx={{
                    color: "#c8c8c8",
                    width: "33px",
                    height: "33px",
                    "&.Mui-checked": {
                        color: "#003300",
                    },
                }}
            />
        </Box>
    );
}
